import { configureStore } from '@reduxjs/toolkit';
import loadOrdersReducer from './ordersSlice';
import orderDetailsReducer from './orderDetailsSlice';
import allUserReducer from './allUsersSlice';
import userFormReducer from './userFormSlice';
import notificationSettingsReducer from './notificationsSettingsSlice';
import storeSettingsReducer from './storeSettingSlice';
import orderDetailInfoReducer from './orderInfoSlice';
import dashboardDataReducer from './dashboardSlice';

// Configure the store
const store = configureStore({
  reducer: {
    loadOrders: loadOrdersReducer,
    orderDetails: orderDetailsReducer,
    allUsers: allUserReducer,
    userForm: userFormReducer,
    notificationSettings: notificationSettingsReducer,
    storeSettings: storeSettingsReducer,
    orderInfo: orderDetailInfoReducer,
    dashboard: dashboardDataReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
